import React, { Component } from 'react'
import { connect } from 'react-redux'
import Tooltip from 'react-tooltip'
import update from 'immutability-helper'

import Red from '../../assets/red.svg'
import Orange from '../../assets/orange.svg'
import Yellow from '../../assets/yellow.svg'
import Green from '../../assets/green.svg'

import { envConstants } from '../../constants'
import {
  callSearch,
  saveFormFilters,
  loadLots,
  callImages
} from '../../actions'
import { holeHelper } from '../../helpers'

const initialState = {
  selectedLocked: '',
  formFilters: [],
  selectFilter: '',
  red: true,
  orange: true,
  yellow: false,
  green: false,
  suggestionCountries: false,
  suggestionRegions: false,
  suggestionDistricts: false,
  suggestionCities: false
}

class Filters extends Component {
  constructor() {
    super()
    this.state = initialState
    this.mouseUp = this.mouseUp.bind(this)
  }

  mouseUp(event) {
    const c = JSON.stringify(event.target.classList)
    const s = this.state
    if (c.indexOf('autocomplete') === -1) {
      if (s.suggestionCountries) {
        this.setState({ suggestionCountries: false })
      }
      if (s.suggestionRegions) {
        this.setState({ suggestionRegions: false })
      }
      if (s.suggestionDistricts) {
        this.setState({ suggestionDistricts: false })
      }
      if (s.suggestionCities) {
        this.setState({ suggestionCities: false })
      }
    }
  }

  changeInput(event, index, fr) {
    const formFilters = update(this.state.formFilters, {
      [index]: {
        value: {
          $set:
            ['owner', 'attendible', 'photo'].indexOf(fr.type) > -1
              ? event.target.checked
              : event.target.value
        }
      }
    })
    this.setState(
      {
        formFilters
      },
      () => {
        this.saveForm()
      }
    )
  }

  changeCheckbox(event) {
    const state = update(this.state, {
      [event.target.name]: { $set: event.target.checked }
    })
    this.setState(
      {
        ...state
      },
      () => {
        this.saveForm()
      }
    )
  }

  setInput(value, index, val) {
    const formFilters = update(this.state.formFilters, {
      [index]: {
        value: { $set: value }
      }
    })
    this.setState(
      {
        formFilters,
        [val]: false
      },
      () => {
        this.saveForm()
      }
    )
  }

  changeMatcher(event, index) {
    const formFilters = update(this.state.formFilters, {
      [index]: {
        matcher: { $set: parseInt(event.target.value, 10) }
      }
    })
    this.setState(
      {
        formFilters
      },
      () => {
        this.saveForm()
      }
    )
  }

  doSearch() {
    window.localStorage.setItem(
      envConstants.ls.dashboard_form,
      JSON.stringify(this.state)
    )
    const s = this.state
    const pq = holeHelper.formFilters(s)
    this.setState(
      {
        suggestionCountries: false,
        suggestionRegions: false,
        suggestionDistricts: false,
        suggestionCities: false
      },
      () => {
        this.props.callSearch({
          locked: s.selectedLocked,
          pq
        })
        // this.props.callImages({
        //   locked: s.selectedLocked,
        //   pq
        // })
      }
    )
  }

  addFilter(event) {
    const fr = this.props.attributes.dashboard.filters.filter(
      (x) => x.filterid === parseInt(event.target.value, 10)
    )
    const formFilters = this.state.formFilters
    if (['owner', 'attendible'].indexOf(fr[0].type) > -1) {
      fr[0].value = true
    } else {
      fr[0].value = ''
    }
    fr[0].matcher = fr[0].comparator[0].id
    formFilters.push(fr[0])
    this.setState(
      {
        formFilters,
        selectFilter: ''
      },
      () => {
        this.saveForm()
      }
    )
  }

  removeFilter(index) {
    const formFilters = this.state.formFilters
    formFilters.splice(index, 1)
    this.setState(
      {
        formFilters
      },
      () => {
        this.saveForm()
      }
    )
  }

  currentLockedFilter() {
    const lockedFilters = this.props.attributes.dashboard.lockedFilters
    if (!lockedFilters) {
      return []
    }
    let cl = this.state.selectedLocked
    if (lockedFilters.length > 0) {
      if (cl === '') {
        cl = lockedFilters[0].id
      }
      const a = lockedFilters.filter((x) => x.id === cl)
      return a[0].filters
    }
    return []
  }

  saveForm() {
    this.props.saveFormFilters(this.state)
  }

  getLotLabel(id) {
    const lots = this.props.detections.lots
    if (!lots) return id
    return (lots || []).filter((x) => x.id === parseInt(id))[0].name
  }

  componentDidMount() {
    const lsf = window.localStorage.getItem(envConstants.ls.dashboard_form)
    if (lsf) {
      const lls = JSON.parse(lsf)
      for (let i = 0; i < lls.formFilters.length; i++) {
        if (
          this.props.attributes.dashboard.filters.filter(
            (x) => x.filterid === lls.formFilters[i].filterid
          ).length === 0
        ) {
          lls.formFilters.splice(i, 1)
        }
      }
      // this.setState({ ...JSON.parse(lsf) })
      // console.log(lls)
      this.setState({ ...lls })
    }

    const formFilters = this.props.dashboard.formFilters
    if (formFilters !== null) {
      this.setState({ ...formFilters })
    }

    const lockedFilters = this.props.attributes.dashboard.lockedFilters
    if (this.state.selectedLocked === '' && lockedFilters) {
      if (lockedFilters.length > 0) {
        this.setState({ selectedLocked: lockedFilters[0].id })
      }
    }

    if (this.props.detections.list === null) {
      this.props.loadLots()
    }
  }

  render() {
    const { countries, regions, districts, cities, licenses } =
      this.props.profile
    const { filters, lockedFilters } = this.props.attributes.dashboard
    const { lots } = this.props.detections
    return (
      <div onMouseUp={(e) => this.mouseUp(e)}>
        <div
          className='search-form-bkg'
          onClick={() => this.props.showSearchForm()}
        ></div>
        <div className='search-form'>
          <h1 className='warning'>
            Filtri ricerca
            {(lockedFilters || []).length > 0 && (
              <i
                className='fas fa-exclamation-triangle'
                data-tip=''
                data-for='lockedFilters'
              ></i>
            )}
          </h1>
          <Tooltip id='lockedFilters' effect='solid'>
            Sono presenti alcuni filtri predefiniti
          </Tooltip>
          {(lockedFilters || []).length > 0 && (
            <div>
              <h2>Filtri predefiniti</h2>
              <select
                value={this.state.selectedLocked}
                onChange={(event) =>
                  this.setState({ selectedLocked: event.target.value })
                }
              >
                {lockedFilters.map((f, index) => {
                  return (
                    <option key={index} value={f.id}>
                      {f.label}
                    </option>
                  )
                })}
              </select>
              <ul className='list-filters'>
                {this.currentLockedFilter().map((f, index) => {
                  return (
                    <li key={index}>
                      <label>{f.label}</label>
                      <ul className='field'>
                        <li className='sl'>
                          <select disabled>
                            <option>{f.comparator.label}</option>
                          </select>
                        </li>
                        <li className='in'>
                          {f.type === 'lot' && (
                            <span className='like-input'>
                              {this.getLotLabel(f.value)}
                            </span>
                          )}
                          {f.type !== 'lot' && (
                            <input type='text' value={f.value} disabled />
                          )}
                        </li>
                      </ul>
                    </li>
                  )
                })}
              </ul>
            </div>
          )}
          <h2>Filtri personalizzati</h2>
          <label className='lbl-filters-dropdown'>
            Aggiungi filtro
            <select
              onChange={(event) => this.addFilter(event)}
              value={this.state.selectFilter}
            >
              <option value=''></option>
              {filters
                .filter((f) => {
                  return (
                    this.state.formFilters.findIndex(
                      (i) => i.filterid === f.filterid
                    ) === -1 ||
                    (f.type === 'date' &&
                      this.state.formFilters.filter(
                        (i) => i.filterid === f.filterid
                      ).length < 2) ||
                    (f.type === 'photo_date' &&
                      this.state.formFilters.filter(
                        (i) => i.filterid === f.filterid
                      ).length < 2)
                  )
                })
                .map((f, index) => {
                  return (
                    <option key={index} value={f.filterid}>
                      {f.label}
                    </option>
                  )
                })}
            </select>
          </label>
          <ul className='list-filters'>
            {this.state.formFilters.map((f, index) => {
              return (
                <li key={index}>
                  <label>{f.label}</label>
                  <ul className='field'>
                    <li className='btn'>
                      <button
                        className='lnk-del-filter'
                        onClick={() => this.removeFilter(index)}
                      >
                        <i className='far fa-trash-alt'></i>
                      </button>
                    </li>
                    <li className='sl'>
                      <select
                        onChange={(event) => this.changeMatcher(event, index)}
                        value={f.matcher}
                      >
                        {f.comparator.map((c, index2) => {
                          return (
                            <option key={index2} value={c.id}>
                              {c.label}
                            </option>
                          )
                        })}
                      </select>
                    </li>
                    <li className='in'>
                      {f.type === 'text' && (
                        <input
                          type='text'
                          value={f.value}
                          onChange={(event) =>
                            this.changeInput(event, index, f)
                          }
                        />
                      )}
                      {f.type === 'country' && (
                        <div className='automcomplete-container'>
                          <input
                            type='text'
                            className='autocomplete-field'
                            value={f.value}
                            onChange={(event) =>
                              this.changeInput(event, index, f)
                            }
                            onFocus={() =>
                              this.setState({ suggestionCountries: true })
                            }
                          />
                          {this.state.suggestionCountries && (
                            <div className='list'>
                              {countries
                                .filter(
                                  (x) =>
                                    x
                                      .toLowerCase()
                                      .indexOf(f.value.toLowerCase()) > -1
                                )
                                .map((c, ic) => {
                                  return (
                                    <button
                                      className='lnk-autocomplete'
                                      onClick={() =>
                                        this.setInput(
                                          c,
                                          index,
                                          'suggestionCountries'
                                        )
                                      }
                                      key={ic}
                                    >
                                      {c}
                                    </button>
                                  )
                                })}
                            </div>
                          )}
                        </div>
                      )}
                      {f.type === 'region' && (
                        <div className='automcomplete-container'>
                          <input
                            type='text'
                            className='autocomplete-field'
                            value={f.value}
                            onChange={(event) =>
                              this.changeInput(event, index, f)
                            }
                            onFocus={() =>
                              this.setState({ suggestionRegions: true })
                            }
                          />
                          {this.state.suggestionRegions && (
                            <div className='list'>
                              {regions
                                .filter(
                                  (x) =>
                                    x
                                      .toLowerCase()
                                      .indexOf(f.value.toLowerCase()) > -1
                                )
                                .map((c, ic) => {
                                  return (
                                    <button
                                      className='lnk-autocomplete'
                                      onClick={() =>
                                        this.setInput(
                                          c,
                                          index,
                                          'suggestionRegions'
                                        )
                                      }
                                      key={ic}
                                    >
                                      {c}
                                    </button>
                                  )
                                })}
                            </div>
                          )}
                        </div>
                      )}
                      {f.type === 'district' && (
                        <div className='automcomplete-container'>
                          <input
                            type='text'
                            className='autocomplete-field'
                            value={f.value}
                            onChange={(event) =>
                              this.changeInput(event, index, f)
                            }
                            onFocus={() =>
                              this.setState({ suggestionDistricts: true })
                            }
                          />
                          {this.state.suggestionDistricts && (
                            <div className='list'>
                              {districts
                                .filter(
                                  (x) =>
                                    x
                                      .toLowerCase()
                                      .indexOf(f.value.toLowerCase()) > -1
                                )
                                .map((c, ic) => {
                                  return (
                                    <button
                                      className='lnk-autocomplete'
                                      onClick={() =>
                                        this.setInput(
                                          c,
                                          index,
                                          'suggestionDistricts'
                                        )
                                      }
                                      key={ic}
                                    >
                                      {c}
                                    </button>
                                  )
                                })}
                            </div>
                          )}
                        </div>
                      )}
                      {f.type === 'city' && (
                        <div className='automcomplete-container'>
                          <input
                            type='text'
                            className='autocomplete-field'
                            value={f.value}
                            onChange={(event) =>
                              this.changeInput(event, index, f)
                            }
                            onFocus={() =>
                              this.setState({ suggestionCities: true })
                            }
                          />
                          {this.state.suggestionCities && (
                            <div className='list'>
                              {cities
                                .filter(
                                  (x) =>
                                    x
                                      .toLowerCase()
                                      .indexOf(f.value.toLowerCase()) > -1
                                )
                                .map((c, ic) => {
                                  return (
                                    <button
                                      className='lnk-autocomplete'
                                      onClick={() =>
                                        this.setInput(
                                          c,
                                          index,
                                          'suggestionCities'
                                        )
                                      }
                                      key={ic}
                                    >
                                      {c}
                                    </button>
                                  )
                                })}
                            </div>
                          )}
                        </div>
                      )}
                      {f.type === 'date' && (
                        <input
                          type='date'
                          value={f.value}
                          onChange={(event) =>
                            this.changeInput(event, index, f)
                          }
                        />
                      )}
                      {f.type === 'photo_date' && (
                        <input
                          type='date'
                          value={f.value}
                          onChange={(event) =>
                            this.changeInput(event, index, f)
                          }
                        />
                      )}
                      {f.type === 'number' && (
                        <input
                          type='number'
                          step='1'
                          value={f.value}
                          onChange={(event) =>
                            this.changeInput(event, index, f)
                          }
                        />
                      )}
                      {f.type === 'severity' && (
                        <div className='severity'>
                          <label className='chk-container'>
                            <img src={Red} alt='red' />
                            <input
                              type='checkbox'
                              name='red'
                              onChange={(event) => this.changeCheckbox(event)}
                              checked={this.state.red}
                            />
                            <span className='checkmark'></span>
                          </label>
                          <label className='chk-container'>
                            <img src={Orange} alt='orange' />
                            <input
                              type='checkbox'
                              name='orange'
                              onChange={(event) => this.changeCheckbox(event)}
                              checked={this.state.orange}
                            />
                            <span className='checkmark'></span>
                          </label>
                          <label className='chk-container'>
                            <img src={Yellow} alt='yellow' />
                            <input
                              type='checkbox'
                              name='yellow'
                              onChange={(event) => this.changeCheckbox(event)}
                              checked={this.state.yellow}
                            />
                            <span className='checkmark'></span>
                          </label>
                          <label className='chk-container'>
                            <img src={Green} alt='green' />
                            <input
                              type='checkbox'
                              name='green'
                              onChange={(event) => this.changeCheckbox(event)}
                              checked={this.state.green}
                            />
                            <span className='checkmark'></span>
                          </label>
                        </div>
                      )}
                      {f.type === 'anomalyType' && (
                        <select
                          value={f.value}
                          onChange={(event) =>
                            this.changeInput(event, index, f)
                          }
                        >
                          <option value=''></option>
                          {envConstants.anomalyTypes.map((t, index) => {
                            return (
                              <option value={t} key={index}>
                                {t}
                              </option>
                            )
                          })}
                        </select>
                      )}
                      {f.type === 'lot' && (
                        <select
                          value={f.value}
                          onChange={(event) =>
                            this.changeInput(event, index, f)
                          }
                        >
                          <option value=''></option>
                          {(lots || []).map((t, index) => {
                            return (
                              <option value={t.id} key={index}>
                                {t.name}
                              </option>
                            )
                          })}
                        </select>
                      )}
                      {f.type === 'attendible' && (
                        <label className='chk-container'>
                          <input
                            type='checkbox'
                            onChange={(event) =>
                              this.changeInput(event, index, f)
                            }
                            checked={f.value}
                          />
                          <span className='checkmark'></span> Attendibile
                          (uguale o superiore a 3 passaggi)
                        </label>
                      )}
                      {f.type === 'photo' && (
                        <label className='chk-container'>
                          <input
                            type='checkbox'
                            onChange={(event) =>
                              this.changeInput(event, index, f)
                            }
                            checked={f.value}
                          />
                          <span className='checkmark'></span> Validate
                        </label>
                      )}
                      {f.type === 'owner' && (
                        <label className='chk-container'>
                          <input
                            type='checkbox'
                            onChange={(event) =>
                              this.changeInput(event, index, f)
                            }
                            checked={f.value}
                          />
                          <span className='checkmark'></span> Sono il
                          proprietario
                        </label>
                      )}
                      {f.type === 'license' && (
                        <div className='automcomplete-container'>
                          <select
                            value={f.value}
                            onChange={(event) =>
                              this.changeInput(event, index, f)
                            }
                          >
                            <option value=''></option>
                            {licenses.map((l, ic) => {
                              return (
                                <option value={l.id} key={ic}>
                                  {l.company} ({l.code})
                                </option>
                              )
                            })}
                          </select>
                        </div>
                      )}
                      {f.type === 'maintenance' && (
                        <select
                          value={f.value}
                          onChange={(event) =>
                            this.changeInput(event, index, f)
                          }
                        >
                          <option value=''></option>
                          <option value='0'>Ordinaria</option>
                          <option value='1'>Straordinaria</option>
                        </select>
                      )}
                      {f.type === 'riparable' && (
                        <select
                          value={f.value}
                          onChange={(event) =>
                            this.changeInput(event, index, f)
                          }
                        >
                          <option value=''></option>
                          <option value='1'>Riparabile</option>
                          <option value='0'>Non riparabile</option>
                        </select>
                      )}
                      {f.type === 'mustberepaired' && (
                        <select
                          value={f.value}
                          onChange={(event) =>
                            this.changeInput(event, index, f)
                          }
                        >
                          <option value=''></option>
                          <option value='1'>Da riparare</option>
                          <option value='0'>Da NON riparare</option>
                        </select>
                      )}
                      {f.type === 'status' && (
                        <select
                          value={f.value}
                          onChange={(event) =>
                            this.changeInput(event, index, f)
                          }
                        >
                          <option value=''></option>
                          <option value='0'>In assegnazione</option>
                          <option value='1'>In lavorazione</option>
                          <option value='2'>Riparata</option>
                          <option value='3'>Risolta</option>
                        </select>
                      )}
                    </li>
                  </ul>
                </li>
              )
            })}
          </ul>
          <button className='lnk-login' onClick={() => this.doSearch()}>
            Cerca
          </button>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  callSearch,
  saveFormFilters,
  loadLots,
  callImages
})(Filters)
